import React, { useEffect } from 'react'
import { Know } from 'interfaces/Know'
import _useTranslation from 'lib/hooks/_useTranslation'
import Meta from 'components/modules/SEO/Meta'
import { KnowExperimentVariants, KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import { setClarityTag } from 'stories/utils/clarity'
import ArticleSchemaData from 'components/modules/SEO/ArticleSchemaData'

interface Props {
    knowSeoInfo: KnowSeoInfo
}

const KnowSEOMeta = ({ knowSeoInfo }: Props) => {
    const { t } = _useTranslation('knows')
    const { know } = knowSeoInfo

    const returnExperimentalVariantTitle = (variant: Know['seoExperimentVariant']) => {
        const documentTitle = `${knowSeoInfo.title.trim()}${know?.subjects?.length ? ` (${know?.subjects[0].name})` : ''}`
        switch (variant) {
            case 1:
                return documentTitle
            case 2:
                return t('knows/experimentalPageTitlePDF', {
                    documentTitle: documentTitle,
                })
            case 3:
                return t('knows/experimentalPageTitleSimpleExplanation', {
                    documentTitle: documentTitle,
                })
        }
    }

    const returnKnowDescription = () =>
        `${t('knows/slugPageDescription', {
            subjects: know?.subjects?.length ? know?.subjects[0].name : 'Knowunity',
            knowType: know?.knowType?.name ?? '',
            grades: know?.grades?.length ? know.grades.map((x) => x.level).join(', ') : '',
        })}`

    useEffect(() => {
        if (!knowSeoInfo?.experimentVariants.includes(KnowExperimentVariants.AiEnhancedVariant)) {
            return
        }

        setClarityTag('ai-enhanced')
    }, [knowSeoInfo?.experimentVariants])

    return (
        <>
            <ArticleSchemaData
                title={knowSeoInfo.title ?? know.title}
                description={knowSeoInfo.description ?? know.description}
                dateModified={knowSeoInfo.updatedOn ?? know.createdOn}
                authorName={know.knower.user.name}
                datePublished={know.createdOn}
            />
            <Meta
                title={know ? returnExperimentalVariantTitle(know.seoExperimentVariant) : 'Know'}
                description={know ? returnKnowDescription() : t('knows/slugDefaultPageDescription')}
                noIndex={know ? !know.isSEOIndexed : false}
                imageUrl={know?.thumbnailSmallUrl ?? undefined}
                type="website"
                canonical
            />
        </>
    )
}

export default KnowSEOMeta
